import React from 'react';
import { useFormContext } from 'react-hook-form';
import { UploadIcon } from 'lucide-react';
const SpecialNeeds = () => {
  const {
    register,
    watch
  } = useFormContext();
  const hasCorporation = watch('corporateInfo.exists');
  return <div className="space-y-8" data-id="element-882">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-883">
        <p className="text-slate-700" data-id="element-884">
          Please provide information about any corporations, dependents with
          special needs, or other special considerations.
        </p>
      </div>

      {/* Corporate Information */}
      <div className="space-y-4" data-id="element-885">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-886">
          Corporate Information
        </h3>

        <div data-id="element-887">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-888">
            Do you own or have an interest in any corporations?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-889">
            <label className="inline-flex items-center" data-id="element-890">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('corporateInfo.exists')} data-id="element-891" />
              <span className="ml-2" data-id="element-892">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-893">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('corporateInfo.exists')} data-id="element-894" />
              <span className="ml-2" data-id="element-895">No</span>
            </label>
          </div>

          {hasCorporation === 'true' && <div className="space-y-4 p-4 bg-slate-50 rounded-md" data-id="element-896">
              <div data-id="element-897">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-898">
                  Name of Corporation
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter corporation name" {...register('corporateInfo.name')} data-id="element-899" />
              </div>

              <div data-id="element-900">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-901">
                  Please provide details about the corporation, the assets it
                  owns, and its shareholders
                </label>
                <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe the corporation's assets, shareholders, and any relevant details" {...register('corporateInfo.details')} data-id="element-902" />
              </div>

              <div data-id="element-903">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-904">
                  Have you entered into a shareholders agreement?
                </label>
                <div className="flex items-center space-x-4 mb-4" data-id="element-905">
                  <label className="inline-flex items-center" data-id="element-906">
                    <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('corporateInfo.shareholdersAgreement')} data-id="element-907" />
                    <span className="ml-2" data-id="element-908">Yes</span>
                  </label>
                  <label className="inline-flex items-center" data-id="element-909">
                    <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('corporateInfo.shareholdersAgreement')} data-id="element-910" />
                    <span className="ml-2" data-id="element-911">No</span>
                  </label>
                </div>
              </div>

              <div data-id="element-912">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-913">
                  Upload Articles of Incorporation (optional)
                </label>
                <div className="border-2 border-dashed border-slate-300 rounded-md p-4 text-center" data-id="element-914">
                  <UploadIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-915" />
                  <p className="mt-2 text-sm text-slate-600" data-id="element-916">
                    Drag and drop your file here, or click to select
                  </p>
                  <input type="file" className="hidden" id="articles-upload" {...register('corporateInfo.articlesFile')} data-id="element-917" />
                  <button type="button" onClick={() => document.getElementById('articles-upload')?.click()} className="mt-2 px-4 py-2 bg-navy-700 text-white text-sm rounded-md hover:bg-navy-800" data-id="element-918">
                    Select File
                  </button>
                </div>
              </div>
            </div>}
        </div>
      </div>

      {/* Dependents with Special Needs */}
      <div className="space-y-4" data-id="element-919">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-920">
          Dependents with Special Needs
        </h3>

        <div data-id="element-921">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-922">
            Do you have any dependents with special needs?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-923">
            <label className="inline-flex items-center" data-id="element-924">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('specialNeeds.exists')} data-id="element-925" />
              <span className="ml-2" data-id="element-926">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-927">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('specialNeeds.exists')} data-id="element-928" />
              <span className="ml-2" data-id="element-929">No</span>
            </label>
          </div>

          {watch('specialNeeds.exists') === 'true' && <div data-id="element-930">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-931">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe the special needs and any relevant details" {...register('specialNeeds.details')} data-id="element-932" />
            </div>}
        </div>
      </div>

      {/* Beneficiaries on ODSP */}
      <div className="space-y-4" data-id="element-933">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-934">
          Beneficiaries on ODSP
        </h3>

        <div data-id="element-935">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-936">
            Do you have any beneficiaries who are on ODSP (Ontario Disability
            Support Program)?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-937">
            <label className="inline-flex items-center" data-id="element-938">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('odspBeneficiaries.exists')} data-id="element-939" />
              <span className="ml-2" data-id="element-940">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-941">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('odspBeneficiaries.exists')} data-id="element-942" />
              <span className="ml-2" data-id="element-943">No</span>
            </label>
          </div>

          {watch('odspBeneficiaries.exists') === 'true' && <div data-id="element-944">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-945">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Provide names and relevant details" {...register('odspBeneficiaries.details')} data-id="element-946" />
            </div>}
        </div>
      </div>

      {/* Other Special Considerations */}
      <div className="space-y-4" data-id="element-947">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-948">
          Other Special Considerations
        </h3>

        <div data-id="element-949">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-950">
            Are there any other special considerations we should be aware of?
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Please describe any other special considerations" {...register('specialConsiderations')} data-id="element-951" />
        </div>
      </div>
    </div>;
};
export default SpecialNeeds;